const WITHDRAWALS_ACTIONS = {
  APPROVE: "APPROVE",
  VIEW_USER: "VIEW_USER",
};

export default WITHDRAWALS_ACTIONS;
